import { CONSOLE_PATHS } from "@sagot/constants";
import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router";
import { RequirePermission } from "../../pages/forbidden-page";
import { GraphPageSkeleton } from "./graph-states";

const KnowledgeGraphPage = lazy(() => import("./knowledge-graph-page").then((module) => ({ default: module.KnowledgeGraphPage })));

/**
 * Knowledge graph (M28, GR-G3-2): beside the Knowledge Base in the sidebar. The page is lazy so the console's first load is
 * unchanged, and it is workspace-wide: the API checks `knowledge.view` at workspace scope, so the route does too.
 */
export const knowledgeGraphRoutes: RouteObject[] = [
  {
    path: CONSOLE_PATHS.knowledgeGraph,
    element: (
      <RequirePermission permission="knowledge.view" mode="workspace">
        <Suspense fallback={<GraphPageSkeleton />}>
          <KnowledgeGraphPage />
        </Suspense>
      </RequirePermission>
    ),
  },
];
